<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item } from '../components/Item.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-04-05',
        major: [],
        excepts: [],
        items: [


          // [NOTE] プリチケセット みらい＆えも
          // ================================================================================

          item({
            collection  : 'PriTickeSet_MiraiEmo',
            id          : 'AM-001',
            rare        : 'SR',
            name        : 'フラワープリンセストップス',
            imgUrl      : '/images/items/AM-001.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeSet_MiraiEmo',
            id          : 'AM-002',
            rare        : 'SR',
            name        : 'フラワープリンセスボトムス',
            imgUrl      : '/images/items/AM-002.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeSet_MiraiEmo',
            id          : 'AM-003',
            rare        : 'SR',
            name        : 'フラワープリンセスあみあげシューズ',
            imgUrl      : '/images/items/AM-003.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeSet_MiraiEmo',
            id          : 'AM-004',
            rare        : 'SR',
            name        : 'フラワープリンセスレースカチューシャ',
            imgUrl      : '/images/items/AM-004.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PriTickeSet_MiraiEmo',
            id          : 'AM-006',
            rare        : 'R',
            name        : 'ポップスターレッドTシャツ',
            imgUrl      : '/images/items/AM-006.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeSet_MiraiEmo',
            id          : 'AM-007',
            rare        : 'R',
            name        : 'ポップスターグリーンキャップスカート',
            imgUrl      : '/images/items/AM-007.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeSet_MiraiEmo',
            id          : 'AM-008',
            rare        : 'R',
            name        : 'ポップスターレッドスニーカー',
            imgUrl      : '/images/items/AM-008.png',
            kind        : 'シューズ',
            color       : '銀',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeSet_MiraiEmo',
            id          : 'AM-009',
            rare        : 'R',
            name        : 'ポップスターヘアアクセ',
            imgUrl      : '/images/items/AM-009.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PriTickeSet_MiraiEmo',
            id          : 'AM-005',
            rare        : 'SR',
            name        : 'フラワープリンセスブーケ',
            imgUrl      : '/images/items/AM-005.png',
            kind        : 'パシャッとアイテム',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeSet_MiraiEmo',
            rare        : 'SR',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'PriTickeSet_MiraiEmo',
            rare        : 'SR',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'PriTickeSet_MiraiEmo',
            rare        : 'SR',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] プリチケセット あんな＆さら
          // ================================================================================

          item({
            collection  : 'PriTickeSet_AnnaSara',
            id          : 'AM-011',
            rare        : 'SR',
            name        : 'ラビットカメオトップス',
            imgUrl      : '/images/items/AM-011.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeSet_AnnaSara',
            id          : 'AM-012',
            rare        : 'SR',
            name        : 'ラビットカメオボトムス',
            imgUrl      : '/images/items/AM-012.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeSet_AnnaSara',
            id          : 'AM-013',
            rare        : 'SR',
            name        : 'ラビットカメオシューズ',
            imgUrl      : '/images/items/AM-013.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeSet_AnnaSara',
            id          : 'AM-014',
            rare        : 'SR',
            name        : 'ラビットカメオヘアアクセ',
            imgUrl      : '/images/items/AM-014.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PriTickeSet_AnnaSara',
            id          : 'AM-015',
            rare        : 'SR',
            name        : 'ベージュのうさぎさんぬいぐるみ',
            imgUrl      : '/images/items/AM-015.png',
            kind        : 'パシャッとアイテム',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeSet_AnnaSara',
            rare        : 'SR',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'PriTickeSet_AnnaSara',
            rare        : 'SR',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'PriTickeSet_AnnaSara',
            rare        : 'SR',
            kind        : 'パシャッとアイテム',
          }),


          item({
            collection  : 'PriTickeSet_AnnaSara',
            id          : 'AM-016',
            rare        : 'R',
            name        : 'ロッカーグリーンベスト＆Tシャツ',
            imgUrl      : '/images/items/AM-016.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeSet_AnnaSara',
            id          : 'AM-017',
            rare        : 'R',
            name        : 'ロッカーダメージデニムショーパン',
            imgUrl      : '/images/items/AM-017.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeSet_AnnaSara',
            id          : 'AM-018',
            rare        : 'R',
            name        : 'ロッカーグリーンローファー',
            imgUrl      : '/images/items/AM-018.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeSet_AnnaSara',
            id          : 'AM-019',
            rare        : 'R',
            name        : 'ロッカーブラックハット',
            imgUrl      : '/images/items/AM-019.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プリチケセット りんか＆める
          // ================================================================================

          item({
            collection  : 'PriTickeSet_RinkaMel',
            id          : 'AM-034',
            rare        : 'SR',
            name        : 'ディスコティックラブトップス',
            imgUrl      : '/images/items/AM-034.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeSet_RinkaMel',
            id          : 'AM-035',
            rare        : 'SR',
            name        : 'ディスコティックラブスカート',
            imgUrl      : '/images/items/AM-035.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeSet_RinkaMel',
            id          : 'AM-036',
            rare        : 'SR',
            name        : 'ディスコティックラブシューズ',
            imgUrl      : '/images/items/AM-036.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeSet_RinkaMel',
            id          : 'AM-037',
            rare        : 'SR',
            name        : 'ディスコティックラブヘアアクセ',
            imgUrl      : '/images/items/AM-037.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PriTickeSet_RinkaMel',
            id          : 'AM-038',
            rare        : 'SR',
            name        : 'ピンキーフェザーせんす',
            imgUrl      : '/images/items/AM-038.png',
            kind        : 'パシャッとアイテム',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeSet_RinkaMel',
            rare        : 'SR',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'PriTickeSet_RinkaMel',
            rare        : 'SR',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'PriTickeSet_RinkaMel',
            rare        : 'SR',
            kind        : 'パシャッとアイテム',
          }),


          item({
            collection  : 'PriTickeSet_RinkaMel',
            id          : 'AM-039',
            rare        : 'R',
            name        : 'クラシックハートライトブルートップス',
            imgUrl      : '/images/items/AM-039.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeSet_RinkaMel',
            id          : 'AM-040',
            rare        : 'R',
            name        : 'クラシックハートライトブルースカート',
            imgUrl      : '/images/items/AM-040.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeSet_RinkaMel',
            id          : 'AM-041',
            rare        : 'R',
            name        : 'クラシックハートライトブルーシューズ',
            imgUrl      : '/images/items/AM-041.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeSet_RinkaMel',
            id          : 'AM-042',
            rare        : 'R',
            name        : 'クラシックハートライトブルーヘアアクセ',
            imgUrl      : '/images/items/AM-042.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プリ☆チャンファイル みらい＆えも
          // ================================================================================

          item({
            collection  : 'PrichanFile_Mirai_Emo',
            id          : 'AM-010',
            rare        : 'R',
            name        : 'スプリングリボンブルーワンピ',
            imgUrl      : '/images/items/AM-010.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrichanFile_Mirai_Emo',
            rare        : 'R',
          }),
          item({
            collection  : 'PrichanFile_Mirai_Emo',
            rare        : 'R',
          }),
          item({
            collection  : 'PrichanFile_Mirai_Emo',
            rare        : 'R',
          }),


          // [NOTE] プリ☆チャンファイル あんな＆さら
          // ================================================================================

          item({
            collection  : 'PrichanFile_Anna_Sara',
            id          : 'AM-020',
            rare        : 'R',
            name        : 'ストライプローズパープルワンピ',
            imgUrl      : '/images/items/AM-020.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'DW',
            type        : 'LO',
            point       : 1000,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrichanFile_Anna_Sara',
            rare        : 'R',
          }),
          item({
            collection  : 'PrichanFile_Anna_Sara',
            rare        : 'R',
          }),
          item({
            collection  : 'PrichanFile_Anna_Sara',
            rare        : 'R',
          }),


          // [NOTE] プリ☆チャンファイル りんか＆める
          // ================================================================================

          item({
            collection  : 'PrichanFile_Rinka_Mel',
            id          : 'AM-043',
            rare        : 'R',
            name        : 'スターダストエメラルドグラデワンピ',
            imgUrl      : '/images/items/AM-043.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 1000,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PrichanFile_Rinka_Mel',
            rare        : 'R',
          }),
          item({
            collection  : 'PrichanFile_Rinka_Mel',
            rare        : 'R',
          }),
          item({
            collection  : 'PrichanFile_Rinka_Mel',
            rare        : 'R',
          }),


          // [NOTE] 限定キラチケ＆ポケットプリチケファイル
          // ================================================================================

          item({
            collection  : 'LimitedKiraTicke_PocketPriTickeFile',
            id          : 'P-027',
            rare        : 'PR',
            name        : 'ゴシックフリルナイトグリーントップス',
            imgUrl      : '/images/items/P-027.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'LimitedKiraTicke_PocketPriTickeFile',
            rare        : 'PR',
          }),
          item({
            collection  : 'LimitedKiraTicke_PocketPriTickeFile',
            rare        : 'PR',
          }),
          item({
            collection  : 'LimitedKiraTicke_PocketPriTickeFile',
            rare        : 'PR',
          }),


          // [NOTE] プリチケMiniファイルコレクション
          // ================================================================================

          item({
            collection  : 'PriTickeMiniFile',
            id          : 'C-015',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームライトブルートップス',
            imgUrl      : '/images/items/C-015.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeMiniFile',
            id          : 'C-016',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームライトブルースカート',
            imgUrl      : '/images/items/C-016.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeMiniFile',
            id          : 'C-017',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームライトブルーシューズ',
            imgUrl      : '/images/items/C-017.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeMiniFile',
            id          : 'C-018',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームライトブルーヘアアクセ',
            imgUrl      : '/images/items/C-018.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'PriTickeMiniFile',
            id          : 'C-019',
            rare        : 'R',
            name        : 'ストロベリーガールパープルワンピ',
            imgUrl      : '/images/items/C-019.png',
            kind        : 'ワンピース',
            color       : '',
            brand       : '',
            type        : '',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeMiniFile',
            id          : 'C-020',
            rare        : 'R',
            name        : 'ストロベリーガールパープルシューズ',
            imgUrl      : '/images/items/C-020.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeMiniFile',
            id          : 'C-021',
            rare        : 'R',
            name        : 'ストロベリーガールパープルヘアアクセ',
            imgUrl      : '/images/items/C-021.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriTickeMiniFile',
            rare        : 'R',
          }),


          // [NOTE] デビューやってみた！キャンペーン！
          // ================================================================================

          item({
            collection  : 'DebutYattemita',
            id          : 'P-001',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームピンクトップス',
            imgUrl      : '/images/items/P-001.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DebutYattemita',
            id          : 'P-002',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームピンクスカート',
            imgUrl      : '/images/items/P-002.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DebutYattemita',
            id          : 'P-003',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームピンクシューズ',
            imgUrl      : '/images/items/P-003.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DebutYattemita',
            id          : 'P-004',
            rare        : 'R',
            name        : 'プリ☆チャンユニフォームピンクヘアアクセ',
            imgUrl      : '/images/items/P-004.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'PS',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] きらきらメモリアルライブ
          // ================================================================================

          item({
            collection  : 'MemorialLive',
            id          : 'P-008',
            rare        : 'SR',
            name        : 'フラワーショップバーベナトップス',
            imgUrl      : '/images/items/P-008.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'MemorialLive',
            id          : 'P-009',
            rare        : 'SR',
            name        : 'フラワーショップバーベナスカート',
            imgUrl      : '/images/items/P-009.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'MemorialLive',
            id          : 'P-010',
            rare        : 'SR',
            name        : 'フラワーショップバーベナシューズ',
            imgUrl      : '/images/items/P-010.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'MemorialLive',
            id          : 'P-011',
            rare        : 'SR',
            name        : 'フラワーショップバーベナヘアアクセ',
            imgUrl      : '/images/items/P-011.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] 公式ファンブック SEASON１
          // ================================================================================

          item({
            collection  : 'Fanbook01',
            id          : 'P-S-010',
            rare        : 'SR',
            name        : 'チアリーダーピンクトップス',
            imgUrl      : '/images/items/P-S-010.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Fanbook01',
            id          : 'P-S-011',
            rare        : 'SR',
            name        : 'チアリーダーピンクスカート',
            imgUrl      : '/images/items/P-S-011.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Fanbook01',
            id          : 'P-S-012',
            rare        : 'SR',
            name        : 'チアリーダーピンクシューズ',
            imgUrl      : '/images/items/P-S-012.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Fanbook01',
            id          : 'P-S-013',
            rare        : 'SR',
            name        : 'チアリーダーピンクヘアアクセ',
            imgUrl      : '/images/items/P-S-013.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] 公式ファンブック SEASON2
          // ================================================================================

          item({
            collection  : 'Fanbook02',
            id          : 'P-S-014',
            rare        : 'SR',
            name        : 'ノーブルドールアクアトップス',
            imgUrl      : '/images/items/P-S-014.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Fanbook02',
            id          : 'P-S-015',
            rare        : 'SR',
            name        : 'ノーブルドールアクアスカート',
            imgUrl      : '/images/items/P-S-015.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Fanbook02',
            id          : 'P-S-016',
            rare        : 'SR',
            name        : 'ノーブルドールアクアシューズ',
            imgUrl      : '/images/items/P-S-016.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Fanbook02',
            id          : 'P-S-017',
            rare        : 'SR',
            name        : 'ノーブルドールアクアヘアアクセ',
            imgUrl      : '/images/items/P-S-017.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] 公式ファンブック SEASON3
          // ================================================================================

          item({
            collection  : 'Fanbook03',
            id          : 'P-S-022',
            rare        : 'SR',
            name        : 'サマーメイドブラックオレンジトップス',
            imgUrl      : '/images/items/P-S-022.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Fanbook03',
            id          : 'P-S-023',
            rare        : 'SR',
            name        : 'サマーメイドブラックオレンジスカート',
            imgUrl      : '/images/items/P-S-023.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Fanbook03',
            id          : 'P-S-024',
            rare        : 'SR',
            name        : 'サマーメイドブラックオレンジシューズ',
            imgUrl      : '/images/items/P-S-024.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Fanbook03',
            id          : 'P-S-025',
            rare        : 'SR',
            name        : 'サマーメイドブラックオレンジヘアアクセ',
            imgUrl      : '/images/items/P-S-025.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Fanbook03',
            id          : 'P-S-026',
            rare        : 'R',
            name        : 'シルバークイーンステッキ',
            imgUrl      : '/images/items/P-S-026.png',
            kind        : 'パシャッとアイテム',
            color       : '',
            brand       : '',
            type        : '',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Fanbook03',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'Fanbook03',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'Fanbook03',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] 公式ファンブック SEASON4
          // ================================================================================

          item({
            collection  : 'Fanbook04',
            id          : 'P-S-031',
            rare        : 'SR',
            name        : 'ハロウィンマジカルパープルトップス',
            imgUrl      : '/images/items/P-S-031.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Fanbook04',
            id          : 'P-S-032',
            rare        : 'SR',
            name        : 'ハロウィンマジカルパープルスカート',
            imgUrl      : '/images/items/P-S-032.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Fanbook04',
            id          : 'P-S-033',
            rare        : 'SR',
            name        : 'ハロウィンマジカルパープルシューズ',
            imgUrl      : '/images/items/P-S-033.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Fanbook04',
            id          : 'P-S-034',
            rare        : 'SR',
            name        : 'ハロウィンマジカルパープルヘアアクセ',
            imgUrl      : '/images/items/P-S-034.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] GAME PriPara Music Collection vol.6
          // ================================================================================

          item({
            collection  : 'GamePriParaMC06',
            id          : 'CD-001',
            rare        : 'R',
            name        : 'ダンシングマーチブルートップス',
            imgUrl      : '/images/items/CD-001.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'GamePriParaMC06',
            id          : 'CD-002',
            rare        : 'R',
            name        : 'ダンシングマーチブルースカート',
            imgUrl      : '/images/items/CD-002.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'GamePriParaMC06',
            id          : 'CD-003',
            rare        : 'R',
            name        : 'ダンシングマーチブルーシューズ',
            imgUrl      : '/images/items/CD-003.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'GamePriParaMC06',
            id          : 'CD-004',
            rare        : 'R',
            name        : 'ダンシングマーチブルーヘアアクセ',
            imgUrl      : '/images/items/CD-004.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] GAME PriPara Music Collection vol.7
          // ================================================================================

          item({
            collection  : 'GamePriParaMC07',
            id          : 'CD-005',
            rare        : 'R',
            name        : 'プリプリしつじバイオレットワンピ',
            imgUrl      : '/images/items/CD-005.png',
            kind        : 'ワンピース',
            color       : '',
            brand       : '',
            type        : '',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'GamePriParaMC07',
            id          : 'CD-006',
            rare        : 'R',
            name        : 'プリプリしつじバイオレットシューズ',
            imgUrl      : '/images/items/CD-006.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'GamePriParaMC07',
            id          : 'CD-007',
            rare        : 'R',
            name        : 'プリプリしつじバイオレットヘアアクセ',
            imgUrl      : '/images/items/CD-007.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'GamePriParaMC07',
            rare        : 'R',
          }),


          item({
            collection  : 'GamePriParaMC07',
            rare        : 'R',
          }),
          item({
            collection  : 'GamePriParaMC07',
            id          : 'CD-008',
            rare        : 'R',
            name        : 'WITHガールズシューズ',
            imgUrl      : '/images/items/CD-008.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'GamePriParaMC07',
            rare        : 'R',
          }),
          item({
            collection  : 'GamePriParaMC07',
            rare        : 'R',
          }),


          // [NOTE] ソングコレクション～1stチャンネル～DX
          // ================================================================================

          item({
            collection  : 'PriChanSC01DX',
            id          : 'P-016',
            rare        : 'R',
            name        : 'イエローローズ',
            imgUrl      : '/images/items/P-016.png',
            kind        : 'パシャッとアイテム',
            color       : '',
            brand       : '',
            type        : '',
            point       : 550,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriChanSC01DX',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'PriChanSC01DX',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'PriChanSC01DX',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] ちゃお 2018年6月号
          // ================================================================================

          item({
            collection  : 'Chao201806',
            id          : 'P-S-001',
            rare        : 'R',
            name        : 'ストロベリーガールミルキーワンピ',
            imgUrl      : '/images/items/P-S-001.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Chao201806',
            id          : 'P-S-002',
            rare        : 'R',
            name        : 'ストロベリーガールミルキーシューズ',
            imgUrl      : '/images/items/P-S-002.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Chao201806',
            id          : 'P-S-003',
            rare        : 'R',
            name        : 'ストロベリーガールミルキーヘアアクセ',
            imgUrl      : '/images/items/P-S-003.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Chao201806',
            rare        : 'R',
          }),


          // [NOTE] ぷっちぐみ 2018年6月号
          // ================================================================================

          item({
            collection  : 'PetitGumi201806',
            id          : 'P-S-004',
            rare        : 'R',
            name        : 'ストロベリーガールジャムワンピ',
            imgUrl      : '/images/items/P-S-004.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PetitGumi201806',
            id          : 'P-S-005',
            rare        : 'R',
            name        : 'ストロベリーガールジャムシューズ',
            imgUrl      : '/images/items/P-S-005.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PetitGumi201806',
            id          : 'P-S-006',
            rare        : 'R',
            name        : 'ストロベリーガールジャムヘアアクセ',
            imgUrl      : '/images/items/P-S-006.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PetitGumi201806',
            rare        : 'R',
          }),


          // [NOTE] 小学一年生 2018年6月号
          // ================================================================================

          item({
            collection  : 'Ichinensei201806',
            id          : 'P-S-007',
            rare        : 'R',
            name        : 'ストロベリーガールクリームワンピ',
            imgUrl      : '/images/items/P-S-007.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Ichinensei201806',
            id          : 'P-S-008',
            rare        : 'R',
            name        : 'ストロベリーガールクリームシューズ',
            imgUrl      : '/images/items/P-S-008.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Ichinensei201806',
            id          : 'P-S-009',
            rare        : 'R',
            name        : 'ストロベリーガールクリームヘアアクセ',
            imgUrl      : '/images/items/P-S-009.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Ichinensei201806',
            rare        : 'R',
          }),


          // [NOTE] ちゃお2018年8月号 応募者全員サービス
          // ================================================================================

          item({
            collection  : 'Chao201808Service',
            id          : 'P-S-018',
            rare        : 'SR',
            name        : 'パンクキャットホワイトレッドトップス',
            imgUrl      : '/images/items/P-S-018.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Chao201808Service',
            id          : 'P-S-019',
            rare        : 'SR',
            name        : 'パンクキャットホワイトレッドスカート',
            imgUrl      : '/images/items/P-S-019.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Chao201808Service',
            id          : 'P-S-020',
            rare        : 'SR',
            name        : 'パンクキャットホワイトレッドシューズ',
            imgUrl      : '/images/items/P-S-020.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Chao201808Service',
            id          : 'P-S-021',
            rare        : 'SR',
            name        : 'パンクキャットホワイトレッドヘアアクセ',
            imgUrl      : '/images/items/P-S-021.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ちゃお 2018年9月号
          // ================================================================================

          item({
            collection  : 'Chao201809',
            id          : 'P-S-027',
            rare        : 'R',
            name        : 'はなやかゆかたふじいろトップス',
            imgUrl      : '/images/items/P-S-027.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Chao201809',
            id          : 'P-S-028',
            rare        : 'R',
            name        : 'はなやかゆかたふじいろスカート',
            imgUrl      : '/images/items/P-S-028.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Chao201809',
            id          : 'P-S-029',
            rare        : 'R',
            name        : 'はなやかゆかたふじいろシューズ',
            imgUrl      : '/images/items/P-S-029.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Chao201809',
            id          : 'P-S-030',
            rare        : 'R',
            name        : 'はなやかゆかたふじいろヘアアクセ',
            imgUrl      : '/images/items/P-S-030.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ちゃお2018年12月号 応募者全員サービス
          // ================================================================================

          item({
            collection  : 'Chao201812Service',
            id          : 'P-S-036',
            rare        : 'SR',
            name        : 'ホイップいちごミントトップス',
            imgUrl      : '/images/items/P-S-036.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Chao201812Service',
            id          : 'P-S-037',
            rare        : 'SR',
            name        : 'ホイップいちごミントスカート',
            imgUrl      : '/images/items/P-S-037.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Chao201812Service',
            id          : 'P-S-038',
            rare        : 'SR',
            name        : 'ホイップいちごミントシューズ',
            imgUrl      : '/images/items/P-S-038.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Chao201812Service',
            id          : 'P-S-039',
            rare        : 'SR',
            name        : 'ホイップいちごミントヘアアクセ',
            imgUrl      : '/images/items/P-S-039.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プリパラオールアイドルパーフェクトステージ！ 同梱特典
          // ================================================================================

          item({
            collection  : 'PerfectStage',
            id          : 'SW-001',
            rare        : 'SR',
            name        : 'そらみ♡スマイルゴールドサイリウムワンピ',
            imgUrl      : '/images/items/SW-001.png',
            kind        : 'ワンピース',
            color       : '金',
            brand       : 'PP_TR',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PerfectStage',
            id          : 'SW-002',
            rare        : 'SR',
            name        : 'そらみ♡スマイルゴールドサイリウムシューズ',
            imgUrl      : '/images/items/SW-002.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'PP_TR',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PerfectStage',
            id          : 'SW-003',
            rare        : 'SR',
            name        : 'そらみ♡スマイルゴールドサイリウムヘアアクセ',
            imgUrl      : '/images/items/SW-003.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'PP_TR',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PerfectStage',
            rare        : 'SR',
          }),


          item({
            collection  : 'PerfectStage',
            id          : 'SW-004',
            rare        : 'SR',
            name        : 'ガァルマゲドンゴールドサイリウムワンピ',
            imgUrl      : '/images/items/SW-004.png',
            kind        : 'ワンピース',
            color       : '金',
            brand       : 'PP_LD',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PerfectStage',
            id          : 'SW-005',
            rare        : 'SR',
            name        : 'ガァルマゲドンゴールドサイリウムシューズ',
            imgUrl      : '/images/items/SW-005.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'PP_LD',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PerfectStage',
            id          : 'SW-006',
            rare        : 'SR',
            name        : 'ガァルマゲドンゴールドサイリウムヘアアクセ',
            imgUrl      : '/images/items/SW-006.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'PP_LD',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PerfectStage',
            rare        : 'SR',
          }),


          item({
            collection  : 'PerfectStage',
            id          : 'SW-007',
            rare        : 'SR',
            name        : 'ドレッシングパフェゴールドサイリウムワンピ',
            imgUrl      : '/images/items/SW-007.png',
            kind        : 'ワンピース',
            color       : '金',
            brand       : 'PP_BM',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PerfectStage',
            id          : 'SW-008',
            rare        : 'SR',
            name        : 'ドレッシングパフェゴールドサイリウムシューズ',
            imgUrl      : '/images/items/SW-008.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'PP_BM',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PerfectStage',
            id          : 'SW-009',
            rare        : 'SR',
            name        : 'ドレッシングパフェゴールドサイリウムヘアアクセ',
            imgUrl      : '/images/items/SW-009.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'PP_BM',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PerfectStage',
            rare        : 'SR',
          }),


          item({
            collection  : 'PerfectStage',
            id          : 'SW-010',
            rare        : 'SR',
            name        : 'トリコロールゴールドサイリウムワンピ',
            imgUrl      : '/images/items/SW-010.png',
            kind        : 'ワンピース',
            color       : '金',
            brand       : 'PP_BP',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PerfectStage',
            id          : 'SW-011',
            rare        : 'SR',
            name        : 'トリコロールゴールドサイリウムシューズ',
            imgUrl      : '/images/items/SW-011.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'PP_BP',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PerfectStage',
            id          : 'SW-012',
            rare        : 'SR',
            name        : 'トリコロールゴールドサイリウムヘアアクセ',
            imgUrl      : '/images/items/SW-012.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'PP_BP',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PerfectStage',
            rare        : 'SR',
          }),


          // [NOTE] サマーメイドスペシャル大会
          // ================================================================================

          item({
            collection  : 'SummerMaidSP',
            id          : 'SP-005',
            rare        : 'SR',
            name        : 'サマーメイドブラックベリートップス',
            imgUrl      : '/images/items/SP-005.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'SummerMaidSP',
            id          : 'SP-006',
            rare        : 'SR',
            name        : 'サマーメイドブラックベリースカート',
            imgUrl      : '/images/items/SP-006.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'SummerMaidSP',
            id          : 'SP-007',
            rare        : 'SR',
            name        : 'サマーメイドブラックベリーシューズ',
            imgUrl      : '/images/items/SP-007.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'SummerMaidSP',
            id          : 'SP-008',
            rare        : 'SR',
            name        : 'サマーメイドブラックベリーヘアアクセ',
            imgUrl      : '/images/items/SP-008.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] サマーメイドスペシャル大会 参加賞品
          // ================================================================================

          item({
            collection  : 'SummerMaidSP_Reward',
            id          : 'P-015',
            rare        : 'KR',
            name        : 'スイートハニーキラッとワンピ',
            imgUrl      : '/images/items/P-015.png',
            kind        : 'ワンピース',
            color       : '',
            brand       : '',
            type        : '',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'SummerMaidSP_Reward',
            rare        : 'KR',
          }),
          item({
            collection  : 'SummerMaidSP_Reward',
            rare        : 'KR',
          }),
          item({
            collection  : 'SummerMaidSP_Reward',
            rare        : 'KR',
          }),


          // [NOTE] ちゃおサマーフェスティバル2018横浜会場
          // ================================================================================

          item({
            collection  : 'ChaoFes2018',
            id          : 'P-017',
            rare        : 'R',
            name        : 'スターダストスカーレットグラデワンピ',
            imgUrl      : '/images/items/P-017.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ChaoFes2018',
            id          : 'P-018',
            rare        : 'R',
            name        : 'スターダストスカーレットグラデシューズ',
            imgUrl      : '/images/items/P-018.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ChaoFes2018',
            id          : 'P-019',
            rare        : 'R',
            name        : 'スターダストスカーレットグラデヘアアクセ',
            imgUrl      : '/images/items/P-019.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ChaoFes2018',
            rare        : 'R',
          }),


          // [NOTE] 「あたり」でもらおう！限定キラチケキャンペーン！
          // ================================================================================

          item({
            collection  : 'LimitedKiraTicke',
            id          : 'P-028',
            rare        : 'KR',
            name        : 'ポップミラクル☆キラッツグループキラッとワンピ',
            imgUrl      : '/images/items/P-028.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : '1900',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'LimitedKiraTicke',
            rare        : 'KR',
          }),
          item({
            collection  : 'LimitedKiraTicke',
            id          : 'P-030',
            rare        : 'KR',
            name        : 'ポップミラクル☆キラッツグループキラッとヘアアクセ',
            imgUrl      : '/images/items/P-030.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'GY',
            type        : 'PO',
            point       : '900',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'LimitedKiraTicke',
            rare        : 'KR',
          }),


          // [NOTE] アンコール上映入場者プレゼント
          // ================================================================================

          item({
            collection  : 'EncoreReward',
            id          : 'P-040',
            rare        : 'SR',
            name        : 'ねこうらないしブラウンワンピ',
            imgUrl      : '/images/items/P-040.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'UQ',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'EncoreReward',
            id          : 'P-044',
            rare        : 'SR',
            name        : 'ねこうらないしブラウンシューズ',
            imgUrl      : '/images/items/P-041.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'EncoreReward',
            id          : 'P-045',
            rare        : 'SR',
            name        : 'ねこうらないしブラウンヘアアクセ',
            imgUrl      : '/images/items/P-042.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'EncoreReward',
            rare        : 'SR',
          }),


          // [NOTE] やってみたアプリセット みらいver.
          // ================================================================================

          item({
            collection  : 'YattemitaAppMirai',
            id          : 'YA-001',
            rare        : 'SR',
            name        : 'ギンガムハートホワイトトップス',
            imgUrl      : '/images/items/YA-001.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaAppMirai',
            id          : 'YA-002',
            rare        : 'SR',
            name        : 'ギンガムハートホワイトスカート',
            imgUrl      : '/images/items/YA-002.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            aggregation : 'YA-001',
          }),
          item({
            collection  : 'YattemitaAppMirai',
            id          : 'YA-003',
            rare        : 'SR',
            name        : 'ギンガムハートホワイトシューズ',
            imgUrl      : '/images/items/YA-003.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 800,
            aggregation : 'YA-001',
          }),
          item({
            collection  : 'YattemitaAppMirai',
            id          : 'YA-004',
            rare        : 'SR',
            name        : 'ギンガムハートホワイトヘアアクセ',
            imgUrl      : '/images/items/YA-004.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            aggregation : 'YA-001',
          }),


          item({
            collection  : 'YattemitaAppMirai',
            id          : 'YA-005',
            rare        : 'SR',
            name        : 'ギンガムハートみらいアプリトップス',
            imgUrl      : '/images/items/YA-005.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaAppMirai',
            id          : 'YA-006',
            rare        : 'SR',
            name        : 'ギンガムハートみらいアプリスカート',
            imgUrl      : '/images/items/YA-006.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            aggregation : 'YA-005',
          }),
          item({
            collection  : 'YattemitaAppMirai',
            id          : 'YA-007',
            rare        : 'SR',
            name        : 'ギンガムハートみらいアプリシューズ',
            imgUrl      : '/images/items/YA-007.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            aggregation : 'YA-005',
          }),
          item({
            collection  : 'YattemitaAppMirai',
            id          : 'YA-008',
            rare        : 'SR',
            name        : 'ギンガムハートみらいアプリヘアアクセ',
            imgUrl      : '/images/items/YA-008.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 650,
            aggregation : 'YA-005',
          }),


          item({
            collection  : 'YattemitaAppMirai',
            id          : 'YA-009',
            rare        : 'PR',
            name        : 'フラワーショップリーフトップス',
            imgUrl      : '/images/items/YA-009.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 830,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaAppMirai',
            id          : 'YA-010',
            rare        : 'PR',
            name        : 'フラワーショップリーフスカート',
            imgUrl      : '/images/items/YA-010.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 780,
            aggregation : 'YA-009',
          }),
          item({
            collection  : 'YattemitaAppMirai',
            id          : 'YA-011',
            rare        : 'PR',
            name        : 'フラワーショップリーフシューズ',
            imgUrl      : '/images/items/YA-011.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-009',
          }),
          item({
            collection  : 'YattemitaAppMirai',
            id          : 'YA-012',
            rare        : 'PR',
            name        : 'フラワーショップリーフヘアアクセ',
            imgUrl      : '/images/items/YA-012.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-009',
          }),


          // [NOTE] やってみたアプリセット えもver.
          // ================================================================================

          item({
            collection  : 'YattemitaAppEmo',
            id          : 'YA-013',
            rare        : 'SR',
            name        : 'ギンガムハートえもアプリトップス',
            imgUrl      : '/images/items/YA-013.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaAppEmo',
            id          : 'YA-014',
            rare        : 'SR',
            name        : 'ギンガムハートえもアプリスカート',
            imgUrl      : '/images/items/YA-014.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            aggregation : 'YA-013',
          }),
          item({
            collection  : 'YattemitaAppEmo',
            id          : 'YA-015',
            rare        : 'SR',
            name        : 'ギンガムハートえもアプリシューズ',
            imgUrl      : '/images/items/YA-015.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            aggregation : 'YA-013',
          }),
          item({
            collection  : 'YattemitaAppEmo',
            id          : 'YA-016',
            rare        : 'SR',
            name        : 'ギンガムハートえもアプリヘアアクセ',
            imgUrl      : '/images/items/YA-016.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 650,
            aggregation : 'YA-013',
          }),


          item({
            collection  : 'YattemitaAppEmo',
            id          : 'YA-017',
            rare        : 'PR',
            name        : 'チアリーダーブルートップス',
            imgUrl      : '/images/items/YA-017.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 780,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaAppEmo',
            id          : 'YA-018',
            rare        : 'PR',
            name        : 'チアリーダーブルースカート',
            imgUrl      : '/images/items/YA-018.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 830,
            aggregation : 'YA-017',
          }),
          item({
            collection  : 'YattemitaAppEmo',
            id          : 'YA-019',
            rare        : 'PR',
            name        : 'チアリーダーブルーシューズ',
            imgUrl      : '/images/items/YA-019.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-017',
          }),
          item({
            collection  : 'YattemitaAppEmo',
            id          : 'YA-020',
            rare        : 'PR',
            name        : 'チアリーダーブルーヘアアクセ',
            imgUrl      : '/images/items/YA-020.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-017',
          }),


          // [NOTE] やってみたアプリセット あんなver.
          // ================================================================================

          item({
            collection  : 'YattemitaAppAnna',
            id          : 'YA-021',
            rare        : 'SR',
            name        : 'ギンガムハートあんなアプリトップス',
            imgUrl      : '/images/items/YA-021.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaAppAnna',
            id          : 'YA-022',
            rare        : 'SR',
            name        : 'ギンガムハートあんなアプリスカート',
            imgUrl      : '/images/items/YA-022.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            aggregation : 'YA-021',
          }),
          item({
            collection  : 'YattemitaAppAnna',
            id          : 'YA-023',
            rare        : 'SR',
            name        : 'ギンガムハートあんなアプリシューズ',
            imgUrl      : '/images/items/YA-023.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            aggregation : 'YA-021',
          }),
          item({
            collection  : 'YattemitaAppAnna',
            id          : 'YA-024',
            rare        : 'SR',
            name        : 'ギンガムハートあんなアプリヘアアクセ',
            imgUrl      : '/images/items/YA-024.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 650,
            aggregation : 'YA-021',
          }),


          item({
            collection  : 'YattemitaAppAnna',
            id          : 'YA-025',
            rare        : 'PR',
            name        : 'ノーブルドールピンクトップス',
            imgUrl      : '/images/items/YA-025.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaAppAnna',
            id          : 'YA-026',
            rare        : 'PR',
            name        : 'ノーブルドールピンクスカート',
            imgUrl      : '/images/items/YA-026.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 780,
            aggregation : 'YA-025',
          }),
          item({
            collection  : 'YattemitaAppAnna',
            id          : 'YA-027',
            rare        : 'PR',
            name        : 'ノーブルドールピンクシューズ',
            imgUrl      : '/images/items/YA-027.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 830,
            aggregation : 'YA-025',
          }),
          item({
            collection  : 'YattemitaAppAnna',
            id          : 'YA-028',
            rare        : 'PR',
            name        : 'ノーブルドールピンクヘアアクセ',
            imgUrl      : '/images/items/YA-028.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-025',
          }),


          // [NOTE] やってみたアプリセット さらver.
          // ================================================================================

          item({
            collection  : 'YattemitaAppSara',
            id          : 'YA-029',
            rare        : 'SR',
            name        : 'ギンガムハートさらアプリトップス',
            imgUrl      : '/images/items/YA-029.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaAppSara',
            id          : 'YA-030',
            rare        : 'SR',
            name        : 'ギンガムハートさらアプリスカート',
            imgUrl      : '/images/items/YA-030.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            aggregation : 'YA-029',
          }),
          item({
            collection  : 'YattemitaAppSara',
            id          : 'YA-031',
            rare        : 'SR',
            name        : 'ギンガムハートさらアプリシューズ',
            imgUrl      : '/images/items/YA-031.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            aggregation : 'YA-029',
          }),
          item({
            collection  : 'YattemitaAppSara',
            id          : 'YA-032',
            rare        : 'SR',
            name        : 'ギンガムハートさらアプリヘアアクセ',
            imgUrl      : '/images/items/YA-032.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 650,
            aggregation : 'YA-029',
          }),


          item({
            collection  : 'YattemitaAppSara',
            id          : 'YA-033',
            rare        : 'PR',
            name        : 'パンクキャットパープルトップス',
            imgUrl      : '/images/items/YA-033.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 830,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaAppSara',
            id          : 'YA-034',
            rare        : 'PR',
            name        : 'パンクキャットパープルスカート',
            imgUrl      : '/images/items/YA-034.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 780,
            aggregation : 'YA-033',
          }),
          item({
            collection  : 'YattemitaAppSara',
            id          : 'YA-035',
            rare        : 'PR',
            name        : 'パンクキャットパープルシューズ',
            imgUrl      : '/images/items/YA-035.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-033',
          }),
          item({
            collection  : 'YattemitaAppSara',
            id          : 'YA-036',
            rare        : 'PR',
            name        : 'パンクキャットパープルヘアアクセ',
            imgUrl      : '/images/items/YA-036.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-033',
          }),


          // [NOTE] やってみたアプリセット ミラクル☆キラッツVer.
          // ================================================================================

          item({
            collection  : 'YattemitaAppKirats',
            id          : 'YA-040',
            rare        : 'PR',
            name        : 'ワイズガールピンクトップス',
            imgUrl      : '/images/items/YA-040.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 830,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaAppKirats',
            id          : 'YA-041',
            rare        : 'PR',
            name        : 'ワイズガールピンクスカート',
            imgUrl      : '/images/items/YA-041.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 780,
            aggregation : 'YA-040',
          }),
          item({
            collection  : 'YattemitaAppKirats',
            id          : 'YA-042',
            rare        : 'PR',
            name        : 'ワイズガールピンクシューズ',
            imgUrl      : '/images/items/YA-042.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-040',
          }),
          item({
            collection  : 'YattemitaAppKirats',
            id          : 'YA-043',
            rare        : 'PR',
            name        : 'ワイズガールピンクヘアアクセ',
            imgUrl      : '/images/items/YA-043.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-040',
          }),


          item({
            collection  : 'YattemitaAppKirats',
            id          : 'YA-044',
            rare        : 'PR',
            name        : 'ワイズガールイエロートップス',
            imgUrl      : '/images/items/YA-044.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 830,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaAppKirats',
            id          : 'YA-045',
            rare        : 'PR',
            name        : 'ワイズガールイエロースカート',
            imgUrl      : '/images/items/YA-045.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 780,
            aggregation : 'YA-044',
          }),
          item({
            collection  : 'YattemitaAppKirats',
            id          : 'YA-046',
            rare        : 'PR',
            name        : 'ワイズガールイエローシューズ',
            imgUrl      : '/images/items/YA-046.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-044',
          }),
          item({
            collection  : 'YattemitaAppKirats',
            id          : 'YA-047',
            rare        : 'PR',
            name        : 'ワイズガールイエローヘアアクセ',
            imgUrl      : '/images/items/YA-047.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-044',
          }),


          item({
            collection  : 'YattemitaAppKirats',
            id          : 'YA-048',
            rare        : 'PR',
            name        : 'ワイズガールブルートップス',
            imgUrl      : '/images/items/YA-048.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 830,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaAppKirats',
            id          : 'YA-049',
            rare        : 'PR',
            name        : 'ワイズガールブルースカート',
            imgUrl      : '/images/items/YA-049.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 780,
            aggregation : 'YA-048',
          }),
          item({
            collection  : 'YattemitaAppKirats',
            id          : 'YA-050',
            rare        : 'PR',
            name        : 'ワイズガールブルーシューズ',
            imgUrl      : '/images/items/YA-050.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-048',
          }),
          item({
            collection  : 'YattemitaAppKirats',
            id          : 'YA-051',
            rare        : 'PR',
            name        : 'ワイズガールブルーヘアアクセ',
            imgUrl      : '/images/items/YA-051.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-048',
          }),


          // [NOTE] やってみたアプリセット メルティックスターVer.
          // ================================================================================

          item({
            collection  : 'YattemitaAppMeltic',
            id          : 'YA-052',
            rare        : 'PR',
            name        : 'ピクニックギンガムピンクケープワンピ',
            imgUrl      : '/images/items/YA-052.png',
            kind        : 'ワンピース',
            color       : '',
            brand       : '',
            type        : '',
            point       : 1610,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaAppMeltic',
            id          : 'YA-053',
            rare        : 'PR',
            name        : 'ピクニックギンガムピンクシューズ',
            imgUrl      : '/images/items/YA-053.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-052',
          }),
          item({
            collection  : 'YattemitaAppMeltic',
            id          : 'YA-054',
            rare        : 'PR',
            name        : 'ピクニックギンガムピンクヘアアクセ',
            imgUrl      : '/images/items/YA-054.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-052',
          }),
          item({
            collection  : 'YattemitaAppMeltic',
            rare        : 'PR',
          }),


          item({
            collection  : 'YattemitaAppMeltic',
            id          : 'YA-055',
            rare        : 'PR',
            name        : 'ピクニックギンガムブラックケープワンピ',
            imgUrl      : '/images/items/YA-055.png',
            kind        : 'ワンピース',
            color       : '',
            brand       : '',
            type        : '',
            point       : 1610,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaAppMeltic',
            id          : 'YA-056',
            rare        : 'PR',
            name        : 'ピクニックギンガムブラックシューズ',
            imgUrl      : '/images/items/YA-056.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-055',
          }),
          item({
            collection  : 'YattemitaAppMeltic',
            id          : 'YA-057',
            rare        : 'PR',
            name        : 'ピクニックギンガムブラックヘアアクセ',
            imgUrl      : '/images/items/YA-057.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-055',
          }),
          item({
            collection  : 'YattemitaAppMeltic',
            rare        : 'PR',
          }),


          item({
            collection  : 'YattemitaAppMeltic',
            id          : 'YA-058',
            rare        : 'PR',
            name        : 'ピクニックギンガムパープルケープワンピ',
            imgUrl      : '/images/items/YA-058.png',
            kind        : 'ワンピース',
            color       : '',
            brand       : '',
            type        : '',
            point       : 1610,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaAppMeltic',
            id          : 'YA-059',
            rare        : 'PR',
            name        : 'ピクニックギンガムパープルシューズ',
            imgUrl      : '/images/items/YA-059.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-058',
          }),
          item({
            collection  : 'YattemitaAppMeltic',
            id          : 'YA-060',
            rare        : 'PR',
            name        : 'ピクニックギンガムパープルヘアアクセ',
            imgUrl      : '/images/items/YA-060.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-058',
          }),
          item({
            collection  : 'YattemitaAppMeltic',
            rare        : 'PR',
          }),


          // [NOTE] やってみたDXセット
          // ================================================================================

          item({
            collection  : 'YattemitaDXSet1',
            id          : 'YA-037',
            rare        : 'SR',
            name        : 'アイスクリームソーダワンピ',
            imgUrl      : '/images/items/YA-037.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet1',
            id          : 'YA-038',
            rare        : 'SR',
            name        : 'アイスクリームソーダシューズ',
            imgUrl      : '/images/items/YA-038.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet1',
            id          : 'YA-039',
            rare        : 'SR',
            name        : 'アイスクリームソーダヘアアクセ',
            imgUrl      : '/images/items/YA-039.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet1',
            rare        : 'SR',
          }),


          item({
            collection  : 'YattemitaDXSet1',
            id          : 'AM-021',
            rare        : 'SR',
            name        : 'フラワーショップアネモネトップス',
            imgUrl      : '/images/items/AM-021.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet1',
            id          : 'AM-022',
            rare        : 'SR',
            name        : 'フラワーショップアネモネスカート',
            imgUrl      : '/images/items/AM-022.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet1',
            id          : 'AM-023',
            rare        : 'SR',
            name        : 'フラワーショップアネモネシューズ',
            imgUrl      : '/images/items/AM-023.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet1',
            id          : 'AM-024',
            rare        : 'SR',
            name        : 'フラワーショップアネモネヘアアクセ',
            imgUrl      : '/images/items/AM-024.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'YattemitaDXSet1',
            id          : 'AM-025',
            rare        : 'SR',
            name        : 'チアリーダーホワイトトップス',
            imgUrl      : '/images/items/AM-025.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet1',
            id          : 'AM-026',
            rare        : 'SR',
            name        : 'チアリーダーホワイトスカート',
            imgUrl      : '/images/items/AM-026.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet1',
            id          : 'AM-027',
            rare        : 'SR',
            name        : 'チアリーダーホワイトシューズ',
            imgUrl      : '/images/items/AM-027.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet1',
            id          : 'AM-028',
            rare        : 'SR',
            name        : 'チアリーダーホワイトヘアアクセ',
            imgUrl      : '/images/items/AM-028.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'YattemitaDXSet1',
            id          : 'AM-029',
            rare        : 'SR',
            name        : 'ゴシックフリルナイトレッドトップス',
            imgUrl      : '/images/items/AM-029.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet1',
            id          : 'AM-030',
            rare        : 'SR',
            name        : 'ゴシックフリルナイトレッドスカート',
            imgUrl      : '/images/items/AM-030.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet1',
            id          : 'AM-031',
            rare        : 'SR',
            name        : 'ゴシックフリルナイトレッドシューズ',
            imgUrl      : '/images/items/AM-031.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet1',
            id          : 'AM-032',
            rare        : 'SR',
            name        : 'ゴシックフリルナイトレッドヘアアクセ',
            imgUrl      : '/images/items/AM-032.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] やってみたDXセット ステージ2
          // ================================================================================

          item({
            collection  : 'YattemitaDXSet2',
            id          : 'YA-087',
            rare        : 'SR',
            name        : 'セーラーマリングリーントップス',
            imgUrl      : '/images/items/YA-087.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet2',
            id          : 'YA-088',
            rare        : 'SR',
            name        : 'セーラーマリングリーンスカート',
            imgUrl      : '/images/items/YA-088.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet2',
            id          : 'YA-089',
            rare        : 'SR',
            name        : 'セーラーマリングリーンシューズ',
            imgUrl      : '/images/items/YA-089.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet2',
            id          : 'YA-090',
            rare        : 'SR',
            name        : 'セーラーマリングリーンヘアアクセ',
            imgUrl      : '/images/items/YA-090.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'YattemitaDXSet2',
            id          : 'AM-044',
            rare        : 'SR',
            name        : 'ノーブルドールラベンダートップス',
            imgUrl      : '/images/items/AM-044.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet2',
            id          : 'AM-045',
            rare        : 'SR',
            name        : 'ノーブルドールラベンダースカート',
            imgUrl      : '/images/items/AM-045.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet2',
            id          : 'AM-046',
            rare        : 'SR',
            name        : 'ノーブルドールラベンダーシューズ',
            imgUrl      : '/images/items/AM-046.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet2',
            id          : 'AM-047',
            rare        : 'SR',
            name        : 'ノーブルドールラベンダーヘアアクセ',
            imgUrl      : '/images/items/AM-047.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'YattemitaDXSet2',
            id          : 'AM-048',
            rare        : 'SR',
            name        : 'パンクキャットブラウンピンクトップス',
            imgUrl      : '/images/items/AM-048.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet2',
            id          : 'AM-049',
            rare        : 'SR',
            name        : 'パンクキャットブラウンピンクスカート',
            imgUrl      : '/images/items/AM-049.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet2',
            id          : 'AM-050',
            rare        : 'SR',
            name        : 'パンクキャットブラウンピンクシューズ',
            imgUrl      : '/images/items/AM-050.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet2',
            id          : 'AM-051',
            rare        : 'SR',
            name        : 'パンクキャットブラウンピンクヘアアクセ',
            imgUrl      : '/images/items/AM-051.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'YattemitaDXSet2',
            id          : 'AM-052',
            rare        : 'SR',
            name        : 'ファンキーファーパープルトップス',
            imgUrl      : '/images/items/AM-052.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet2',
            id          : 'AM-053',
            rare        : 'SR',
            name        : 'ファンキーファーパープルスカート',
            imgUrl      : '/images/items/AM-053.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet2',
            id          : 'AM-054',
            rare        : 'SR',
            name        : 'ファンキーファーパープルピンクシューズ',
            imgUrl      : '/images/items/AM-054.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'YattemitaDXSet2',
            id          : 'AM-055',
            rare        : 'SR',
            name        : 'ファンキーファーパープルヘアアクセ',
            imgUrl      : '/images/items/AM-055.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プリ☆チャンキャスト アンジュDXセット／みらいDXセット／やってみたアプリセットキラッとオールスターVer.
          // ================================================================================

          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-061',
            rare        : 'PR',
            name        : 'シャイニースターコスモストップス',
            imgUrl      : '/images/items/YA-061.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 830,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-062',
            rare        : 'PR',
            name        : 'シャイニースターコスモススカート',
            imgUrl      : '/images/items/YA-062.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 780,
            aggregation : 'YA-061',
          }),
          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-063',
            rare        : 'PR',
            name        : 'シャイニースターコスモスシューズ',
            imgUrl      : '/images/items/YA-063.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-061',
          }),
          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-064',
            rare        : 'PR',
            name        : 'シャイニースターコスモスヘアアクセ',
            imgUrl      : '/images/items/YA-064.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-061',
          }),


          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-065',
            rare        : 'KR',
            name        : 'スイートハニーミラクル☆キラッツキラッとワンピ',
            imgUrl      : '/images/items/YA-065.png',
            kind        : 'ワンピース',
            color       : '',
            brand       : '',
            type        : '',
            point       : 1570,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-066',
            rare        : 'KR',
            name        : 'スイートハニーミラクル☆キラッツキラッとシューズ',
            imgUrl      : '/images/items/YA-066.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            aggregation : 'YA-065',
          }),
          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-067',
            rare        : 'KR',
            name        : 'スイートハニーミラクル☆キラッツキラッとヘアアクセ',
            imgUrl      : '/images/items/YA-067.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            aggregation : 'YA-065',
          }),
          item({
            collection  : 'PriCas_DXSet',
            rare        : 'KR',
          }),


          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-068',
            rare        : 'KR',
            name        : 'ガールズエールミラクル☆キラッツキラッとワンピ',
            imgUrl      : '/images/items/YA-068.png',
            kind        : 'ワンピース',
            color       : '',
            brand       : '',
            type        : '',
            point       : 1570,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-069',
            rare        : 'KR',
            name        : 'ガールズエールミラクル☆キラッツキラッとシューズ',
            imgUrl      : '/images/items/YA-069.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            aggregation : 'YA-068',
          }),
          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-070',
            rare        : 'KR',
            name        : 'ガールズエールミラクル☆キラッツキラッとヘアアクセ',
            imgUrl      : '/images/items/YA-070.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            aggregation : 'YA-068',
          }),
          item({
            collection  : 'PriCas_DXSet',
            rare        : 'KR',
          }),


          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-071',
            rare        : 'KR',
            name        : 'シークレットアリスミラクル☆キラッツキラッとワンピ',
            imgUrl      : '/images/items/YA-071.png',
            kind        : 'ワンピース',
            color       : '',
            brand       : '',
            type        : '',
            point       : 1570,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-072',
            rare        : 'KR',
            name        : 'シークレットアリスミラクル☆キラッツキラッとシューズ',
            imgUrl      : '/images/items/YA-072.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            aggregation : 'YA-071',
          }),
          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-073',
            rare        : 'KR',
            name        : 'シークレットアリスミラクル☆キラッツキラッとヘアアクセ',
            imgUrl      : '/images/items/YA-073.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            aggregation : 'YA-071',
          }),
          item({
            collection  : 'PriCas_DXSet',
            rare        : 'KR',
          }),


          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-074',
            rare        : 'KR',
            name        : 'ドーリーワルツメルティックスターキラッとワンピ',
            imgUrl      : '/images/items/YA-074.png',
            kind        : 'ワンピース',
            color       : '',
            brand       : '',
            type        : '',
            point       : 1570,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-075',
            rare        : 'KR',
            name        : 'ドーリーワルツメルティックスターキラッとシューズ',
            imgUrl      : '/images/items/YA-075.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            aggregation : 'YA-074',
          }),
          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-076',
            rare        : 'KR',
            name        : 'ドーリーワルツメルティックスターキラッとヘアアクセ',
            imgUrl      : '/images/items/YA-076.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            aggregation : 'YA-074',
          }),
          item({
            collection  : 'PriCas_DXSet',
            rare        : 'KR',
          }),


          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-077',
            rare        : 'KR',
            name        : 'ロマンスビートメルティックスターキラッとワンピ',
            imgUrl      : '/images/items/YA-077.png',
            kind        : 'ワンピース',
            color       : '',
            brand       : '',
            type        : '',
            point       : 1570,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-078',
            rare        : 'KR',
            name        : 'ロマンスビートメルティックスターキラッとシューズ',
            imgUrl      : '/images/items/YA-078.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            aggregation : 'YA-077',
          }),
          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-079',
            rare        : 'KR',
            name        : 'ロマンスビートメルティックスターキラッとヘアアクセ',
            imgUrl      : '/images/items/YA-079.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            aggregation : 'YA-077',
          }),
          item({
            collection  : 'PriCas_DXSet',
            rare        : 'KR',
          }),


          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-080',
            rare        : 'KR',
            name        : 'ユニバースクイーンメルティックスターキラッとワンピ',
            imgUrl      : '/images/items/YA-080.png',
            kind        : 'ワンピース',
            color       : '',
            brand       : '',
            type        : '',
            point       : 1570,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-081',
            rare        : 'KR',
            name        : 'ユニバースクイーンメルティックスターキラッとシューズ',
            imgUrl      : '/images/items/YA-081.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            aggregation : 'YA-080',
          }),
          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-082',
            rare        : 'KR',
            name        : 'ユニバースクイーンメルティックスターキラッとヘアアクセ',
            imgUrl      : '/images/items/YA-082.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            aggregation : 'YA-080',
          }),
          item({
            collection  : 'PriCas_DXSet',
            rare        : 'KR',
          }),


          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-083',
            rare        : 'PR',
            name        : 'シャイニースターエメラルドトップス',
            imgUrl      : '/images/items/YA-083.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 830,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-084',
            rare        : 'PR',
            name        : 'シャイニースターエメラルドスカート',
            imgUrl      : '/images/items/YA-084.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 780,
            aggregation : 'YA-083',
          }),
          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-085',
            rare        : 'PR',
            name        : 'シャイニースターエメラルドシューズ',
            imgUrl      : '/images/items/YA-085.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-083',
          }),
          item({
            collection  : 'PriCas_DXSet',
            id          : 'YA-086',
            rare        : 'PR',
            name        : 'シャイニースターエメラルドヘアアクセ',
            imgUrl      : '/images/items/YA-086.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 730,
            aggregation : 'YA-083',
          }),


          // [NOTE] プリ☆チャンキャスト アンジュDXセット／みらいDXセット 限定特典
          // ================================================================================

          item({
            collection  : 'PriCas_DXSet_Reward',
            id          : 'P-027',
            rare        : 'PR',
            name        : 'ゴシックフリルナイトグリーントップス',
            imgUrl      : '/images/items/P-027.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 950,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriCas_DXSet_Reward',
            rare        : 'PR',
          }),
          item({
            collection  : 'PriCas_DXSet_Reward',
            rare        : 'PR',
          }),
          item({
            collection  : 'PriCas_DXSet_Reward',
            rare        : 'PR',
          }),


          item({
            collection  : 'PriCas_DXSet_Reward',
            id          : 'AM-033',
            rare        : 'SR',
            name        : 'なかよしまくら',
            imgUrl      : '/images/items/AM-033.png',
            kind        : 'パシャッとアイテム',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PriCas_DXSet_Reward',
            rare        : 'SR',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'PriCas_DXSet_Reward',
            rare        : 'SR',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'PriCas_DXSet_Reward',
            rare        : 'SR',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] アプリケース みらい＆スイートハニー
          // ================================================================================

          item({
            collection  : 'AppCase_Mirai_SH',
            id          : 'AM-056',
            rare        : 'SR',
            name        : 'わんわんポリスグリーントップス',
            imgUrl      : '/images/items/AM-056_28254.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'AppCase_Mirai_SH',
            rare        : 'SR',
          }),
          item({
            collection  : 'AppCase_Mirai_SH',
            rare        : 'SR',
          }),
          item({
            collection  : 'AppCase_Mirai_SH',
            id          : 'AM-057',
            rare        : 'SR',
            name        : 'わんわんポリスグリーンヘアアクセ',
            imgUrl      : '/images/items/AM-057_28255.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] アプリケース アンジュ＆プレシャスミューズ
          // ================================================================================

          item({
            collection  : 'AppCase_Ange_PM',
            rare        : 'SR',
          }),
          item({
            collection  : 'AppCase_Ange_PM',
            id          : 'AM-058',
            rare        : 'SR',
            name        : 'わんわんポリスグリーンスカート',
            imgUrl      : '/images/items/AM-058_28256.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'AppCase_Ange_PM',
            id          : 'AM-059',
            rare        : 'SR',
            name        : 'わんわんポリスグリーンシューズ',
            imgUrl      : '/images/items/AM-059_28257.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'AppCase_Ange_PM',
            rare        : 'SR',
          }),


          // [NOTE] キラッとプリ☆チャン DVD/BD-BOX-1 DVD/BD-BOX-2
          // ================================================================================

          item({
            collection  : 'DVDBDBOX_1_2',
            id          : 'P-020',
            rare        : 'SR',
            name        : 'チョコホイップクリームトップス',
            imgUrl      : '/images/items/P-020.png',
            kind        : 'トップス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DVDBDBOX_1_2',
            id          : 'P-021',
            rare        : 'SR',
            name        : 'チョコホイップクリームスカート',
            imgUrl      : '/images/items/P-021.png',
            kind        : 'ボトムス',
            color       : '',
            brand       : '',
            type        : '',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DVDBDBOX_1_2',
            id          : 'P-022',
            rare        : 'SR',
            name        : 'チョコホイップクリームシューズ',
            imgUrl      : '/images/items/P-022.png',
            kind        : 'シューズ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'DVDBDBOX_1_2',
            id          : 'P-023',
            rare        : 'SR',
            name        : 'チョコホイップクリームヘアアクセ',
            imgUrl      : '/images/items/P-023.png',
            kind        : 'ヘアアクセ',
            color       : '',
            brand       : '',
            type        : '',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


        ]
      }
    },

    methods: {
      collection (collection = '', rare = '') {
        return rare
          ? _.where(this.items, { collection, rare })
          : _.where(this.items, { collection })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[2]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="プリチケセット みらい＆えも" color="#00c7da" :items="collection('PriTickeSet_MiraiEmo', 'SR')" />
      <ItemList title="" color="#feab0d" :items="collection('PriTickeSet_MiraiEmo', 'R')" />

      <ItemList title="プリチケセット あんな＆さら" color="#00c7da" :items="collection('PriTickeSet_AnnaSara', 'SR')" />
      <ItemList title="" color="#feab0d" :items="collection('PriTickeSet_AnnaSara', 'R')" />

      <ItemList title="プリチケセット りんか＆める" color="#00c7da" :items="collection('PriTickeSet_RinkaMel', 'SR')" />
      <ItemList title="" color="#feab0d" :items="collection('PriTickeSet_RinkaMel', 'R')" />

      <ItemList title="プリチケMiniファイルコレクション" color="#feab0d" :items="collection('PriTickeMiniFile')" />
    </template>

    <template #col2>
      <ItemList title="プリ☆チャンファイル|みらい＆えも" color="#feab0d" :items="collection('PrichanFile_Mirai_Emo')" />
      <ItemList title="プリ☆チャンファイル|あんな＆さら" color="#feab0d" :items="collection('PrichanFile_Anna_Sara')" />
      <ItemList title="プリ☆チャンファイル|りんか＆める" color="#feab0d" :items="collection('PrichanFile_Rinka_Mel')" />
      <ItemList title="限定キラチケ＆|ポケットプリチケファイル" color="#ffa1bc" :items="collection('LimitedKiraTicke_PocketPriTickeFile')" />
    </template>

    <template #col3>
      <ItemList title="公式ファンブック SEASON1" color="#00c7da" :items="collection('Fanbook01')" />
      <ItemList title="公式ファンブック SEASON2" color="#00c7da" :items="collection('Fanbook02')" />
      <ItemList title="公式ファンブック SEASON3" color="#00c7da" :items="collection('Fanbook03', 'SR')" />
      <ItemList title="" color="#feab0d" :items="collection('Fanbook03', 'R')" />
      <ItemList title="公式ファンブック SEASON4" color="#00c7da" :items="collection('Fanbook04')" />
      <ItemList title="GAME PriPara|Music Collection vol.6" color="#feab0d" :items="collection('GamePriParaMC06')" />
      <ItemList title="GAME PriPara|Music Collection vol.7" color="#feab0d" :items="collection('GamePriParaMC07')" />
      <ItemList title="ソングコレクション|～1stチャンネル～DX" color="#feab0d" :items="collection('PriChanSC01DX')" />
    </template>

    <template #col4>
      <ItemList title="ちゃお 2018年6月号" color="#feab0d" :items="collection('Chao201806')" />
      <ItemList title="ぷっちぐみ 2018年6月号" color="#feab0d" :items="collection('PetitGumi201806')" />
      <ItemList title="小学一年生 2018年6月号" color="#feab0d" :items="collection('Ichinensei201806')" />
      <ItemList title="ちゃお2018年8月号|応募者全員サービス" color="#00c7da" :items="collection('Chao201808Service')" />
      <ItemList title="ちゃお 2018年9月号" color="#feab0d" :items="collection('Chao201809')" />
      <ItemList title="ちゃお2018年12月号|応募者全員サービス" color="#00c7da" :items="collection('Chao201812Service')" />
    </template>

    <template #col5>
      <ItemList title="デビューやってみた！|キャンペーン！" color="#ffa1bc" :items="collection('DebutYattemita')" />
      <ItemList title="きらきらメモリアルライブ" color="#ffa1bc" :items="collection('MemorialLive')" />
      <ItemList title="サマーメイドスペシャル大会" color="#00c7da" :items="collection('SummerMaidSP')" />
      <ItemList title="" color="#ff5d91" :items="collection('SummerMaidSP_Reward')" />
      <ItemList title="ちゃおフェス2018横浜会場" color="#00c7da" :items="collection('ChaoFes2018')" />
      <ItemList title="「あたり」でもらおう！|限定キラチケキャンペーン！" color="#ff5d91" :items="collection('LimitedKiraTicke')" />
      <ItemList title="アンコール上映入場者プレゼント" color="#00c7da" :items="collection('EncoreReward')" />
    </template>

    <template #col6>
      <ItemList title="やってみたアプリセット|みらいver." color="#ffa1bc" :items="collection('YattemitaAppMirai', 'PR')" />
      <ItemList title="" color="#00c7da" :items="collection('YattemitaAppMirai', 'SR')" />
      <ItemList title="やってみたアプリセット|えもver." color="#ffa1bc" :items="collection('YattemitaAppEmo', 'PR')" />
      <ItemList title="" color="#00c7da" :items="collection('YattemitaAppEmo', 'SR')" />
      <ItemList title="やってみたアプリセット|あんなver." color="#ffa1bc" :items="collection('YattemitaAppAnna', 'PR')" />
      <ItemList title="" color="#00c7da" :items="collection('YattemitaAppAnna', 'SR')" />
      <ItemList title="やってみたアプリセット|さらver." color="#ffa1bc" :items="collection('YattemitaAppSara', 'PR')" />
      <ItemList title="" color="#00c7da" :items="collection('YattemitaAppSara', 'SR')" />
    </template>

    <template #col7>
      <ItemList title="やってみたアプリセット|ミラクル☆キラッツver." color="#ffa1bc" :items="collection('YattemitaAppKirats')" />
      <ItemList title="やってみたアプリセット|メルティックスターver." color="#ffa1bc" :items="collection('YattemitaAppMeltic')" />
    </template>

    <template #col8>
      <ItemList title="プリ☆チャンキャスト|みらい／アンジュ DXセット" color="#ff5d91" :items="collection('PriCas_DXSet', 'KR')" />
      <ItemList title="" color="#ffa1bc" :items="collection('PriCas_DXSet', 'PR')" />
      <ItemList title="プリ☆チャンキャスト|みらい／アンジュ DXセット|限定特典" color="#00c7da" :items="collection('PriCas_DXSet_Reward', 'PR')" />
      <ItemList title="" color="#ffa1bc" :items="collection('PriCas_DXSet_Reward', 'SR')" />
    </template>

    <template #col9>
      <ItemList title="やってみたDXセット" color="#00c7da" :items="collection('YattemitaDXSet1')" />
      <ItemList title="やってみたDXセット|ステージ2" color="#00c7da" :items="collection('YattemitaDXSet2')" />
    </template>

    <template #col10>
      <ItemList title="アプリケース|みらい＆スイートハニー" color="#00c7da" :items="collection('AppCase_Mirai_SH')" />
      <ItemList title="アプリケース|アンジュ＆プレシャスミューズ" color="#00c7da" :items="collection('AppCase_Ange_PM')" />
      <ItemList title="キラッとプリ☆チャン|DVD/BD-BOX-1|DVD/BD-BOX-2" color="#00c7da" :items="collection('DVDBDBOX_1_2')" />
      <ItemList title="プリパラオールアイドルパーフェクトステージ！同梱特典" color="#00c7da" :items="collection('PerfectStage')" />
      <Status :date="date" :items="items" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    // right: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }
</style>
